import SchedulerResourceProps from './Resources'

let KendoSchedulerResource = {
    name: 'kendo-scheduler-resource',
    render () {
        return null
    },
    mixins: [SchedulerResourceProps]
}

export default KendoSchedulerResource


// WEBPACK FOOTER //
// ./packages/kendo-scheduler-vue-wrapper/src/KendoSchedulerResource/index.js